module.exports = __webpack_public_path__ + "img/hm_bg.8428b4e3.png";